module.exports = __webpack_public_path__ + "img/KW.65b48118.svg";